import React from "react";
import cn from "classnames";
import { Row, TableInstance, TableRowProps } from "react-table";

export type DataTableBodyProps<T extends object = {}> = TableInstance<T> & {
  rowStyle?: (row: T) => string | undefined;
};

export const DataTableBody = <T extends object = {}>(
  props: DataTableBodyProps<T>
) => {
  const { columns, getTableBodyProps, page, prepareRow, rowStyle } = props;
  const getRowStyle = (row: Row<T>): TableRowProps => {
    // If no rowStyle provided, just return the RowProps as is.
    if (!rowStyle) return row.getRowProps();

    // Deconstruct className from RowProps to update.
    const { className, ...rest } = row.getRowProps();

    // Update the className prop based on the rowStyle fn provided.
    const output = cn(className, rowStyle(row.original));

    // Return the updated RowProp
    return { className: output, ...rest };
  };

  return (
    <tbody {...getTableBodyProps()}>
      {page.length > 0 ? (
        page.map((row) => {
          prepareRow(row);
          return (
            <tr {...getRowStyle(row)}>
              {row.cells.map((cell) => (
                <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
              ))}
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={columns.length} className="text-center">
            - Empty -
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default TableInstance;
